<template>
  <div class="matching-box clearfix">
    <vxe-form
        :data="formData"
        :rules="formRules"
        title-colon
        ref="xForm"
        title-width="120"
        title-align="right"
    >
      <vxe-form-item title="货物类型" field="goodsType" span="8">
        <template>
          <div class="matching-inner-box matching-inner-box-2" v-if="isDetail">
            {{ formData.goodsType }}
          </div>
          <vxe-select
              v-model="formData.goodsType"
              transfer
              placeholder="请选择"
              :options="goodsTypeOptions"
              @change="clearValidate"
              v-else
          >
          </vxe-select>
        </template>
      </vxe-form-item>
      <vxe-form-item title="货名" field="goodsName" span="8">
        <template>
          <div class="matching-inner-box matching-inner-box-2" v-if="isDetail">
            {{ formData.goodsName }}
          </div>
          <vxe-input
              v-model="formData.goodsName"
              placeholder="必填"
              @input="clearValidate"
              clearable
              v-else
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="单位" field="goodsUnit" span="8">
        <template>
          <div class="matching-inner-box matching-inner-box-2" v-if="isDetail">
            {{ formData.goodsUnit }}
          </div>
          <vxe-select
              v-model="formData.goodsUnit"
              transfer
              placeholder="请选择"
              :options="unitTypeOptions"
              @change="clearValidate"
              v-else
          >
          </vxe-select>
        </template>
      </vxe-form-item>
      <!--      <vxe-form-item title="合同数量" field="goodsCounts" span="8">-->
      <!--        <template>-->
      <!--          <div class="matching-inner-box matching-inner-box-2" v-if="isDetail">-->
      <!--            {{ formData.goodsCounts }}-->
      <!--          </div>-->
      <!--          <vxe-input-->
      <!--            v-model="formData.goodsCounts"-->
      <!--            placeholder="必填"-->
      <!--            @input="clearValidate"-->
      <!--            clearable-->
      <!--            v-else-->
      <!--          ></vxe-input>-->
      <!--        </template>-->
      <!--      </vxe-form-item>-->
      <vxe-form-item title="计费方式" field="priceType" span="8">
        <template>
          <div class="matching-inner-box matching-inner-box-2" v-if="isDetail">
            {{ formData.priceType | priceTypeMap }}
          </div>
          <vxe-select
              v-model="formData.priceType"
              transfer
              placeholder="请选择"
              :options="busType === 2 ? priceType1 : priceType2"
              @change="clearValidate"
              v-else
          >
          </vxe-select>
        </template>
      </vxe-form-item>
      <vxe-form-item title="单价" field="price" span="8">
        <template>
          <div class="matching-inner-box matching-inner-box-2" v-if="isDetail">
            {{ formData.price }}
          </div>
          <vxe-input
              v-model.trim="formData.price"
              :placeholder="formData.priceType === 1 ? '必填' : '选填'"
              @input="computeAmount($event, 'price')"
              clearable
              v-else
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="结算数量" field="realCount" span="8">
        <template>
          <div class="matching-inner-box matching-inner-box-2" v-if="isDetail">
            {{ formData.realCount }}
          </div>
          <vxe-input
              v-model.trim="formData.realCount"
              placeholder="选填"
              @input="computeAmount($event, 'realCount')"
              clearable
              v-else
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="运费金额" field="freightAmount" span="8">
        <template>
          <div class="matching-inner-box matching-inner-box-2" v-if="isDetail">
            {{ formData.freightAmount }}
          </div>
          <vxe-input
              v-model.trim="formData.freightAmount"
              placeholder="选填"
              type="float"
              :digits="2"
              @input="computeAmount($event, 'freightAmount')"
              v-else
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="滞期费" field="demurrageAmount" span="8">
        <template>
          <div class="matching-inner-box matching-inner-box-2" v-if="isDetail">
            {{ formData.demurrageAmount }}
          </div>
          <vxe-input
              v-model.trim="formData.demurrageAmount"
              placeholder="选填"
              type="float"
              :digits="2"
              @input="computeAmount($event, 'demurrageAmount')"
              v-else
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="总运费金额" field="payAmount" span="8">
        <template>
          <div class="matching-inner-box matching-inner-box-2" v-if="isDetail">
            {{ formData.payAmount === 0 ? '' : formData.payAmount }}
          </div>
          <vxe-input
              readonly
              v-model.trim="formData.payAmount"
              :placeholder="formData.priceType === 2 || formData.priceType === 3 ? '必填' : '实际运费金额'"
              type="float"
              :digits="2"
              clearable
              v-else
          ></vxe-input>
        </template>
      </vxe-form-item>
    </vxe-form>
  </div>
</template>

<script>
import $C from "@/consts/index";
import $api from "@/apiProvider";
import {add, mul} from "@/utils/tools.js";
import {mapGetters} from "vuex";

export default {
  props: {
    busType: Number,
    isSubmit: Boolean,
    detailData: Object,
    isDetail: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      formData: {
        goodsType: null,
        goodsName: null,
        goodsUnit: null,
        goodsCounts: null,
        priceType: null,
        price: null,
        realCount: null,
        payAmount: null,
        freightAmount: null,
        demurrageAmount: null,
      },
      formRules: {
        goodsType: [{required: true, message: "请选择货物类型"}],
        goodsName: [{required: true, message: "请填写货名"}],
        goodsUnit: [{required: true, message: "请选择货物单位"}],
        goodsCounts: [{required: true, message: "请填写合同数量"}],
        priceType: [{required: true, message: "请选择计费方式"}],
        price: [{required: false, message: "请输入单价"}],
        payAmount: [{required: false, message: "请输入总运费金额"}],
      },
      contractListType: [],
      priceType1: $C.PRICE_TYPE_1,
      priceType2: $C.PRICE_TYPE_2,
      goodsTypeOptions: [],
      unitTypeOptions: [],
      isEdit: false,
      initPayAmount: null,
    };
  },
  watch: {
    busType(nv, ov) {
      if (nv !== ov) {
        this.formData.priceType = null
      }
    },
    "formData.priceType": {
      immediate: true,
      handler(val) {
        if (val === 1) {
          this.formRules.price[0].required = true;
          this.formRules.payAmount[0].required = false;
        } else if (val === 2 || val === 3) {
          this.formRules.price[0].required = false;
          this.formRules.payAmount[0].required = true;
        }
      },
    },
    isSubmit(val) {
      if (val) {
        this.setParams();
      }
    },
    detailData: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val) {
          this.isEdit = true;
          this.formData.goodsType = val.goodsType;
          this.formData.goodsName = val.goodsName;
          this.formData.goodsUnit = val.goodsUnit;
          this.formData.goodsCounts = val.goodsCounts;
          this.formData.contractCount = val.contractCount;
          this.formData.priceType = val.priceType;
          this.formData.price = val.price;
          this.formData.realCount = val.realCount;
          this.formData.payAmount = val.payAmount;
          this.formData.demurrageAmount = val.demurrageAmount;
          this.formData.freightAmount = val.freightAmount;
          this.formData.preFreightAmount = val.preFreightAmount;
          this.initPayAmount = val.payAmount;
        } else {
          this.isEdit = false;
        }
      },
    },
    chooseMatchingAgreementObjGetter(val) {
      this.formData.goodsName = val.goodsName;
      if (val.dataType === 2) {
        //运输模板
        this.formData.goodsUnit = val.pack;
        this.formData.goodsCounts = val.goodsCount;
        this.formData.goodsType = val.goodsType;
        if (val.priceText) {
          if (val.priceText === '单价') {
            this.formData.priceType = 1;
          } else if (val.priceText === '包车') {
            this.formData.priceType = 2;
          } else if (val.priceText === '包船') {
            this.formData.priceType = 3;
          }
        }
      } else {
        this.formData.goodsType = null;
        this.formData.goodsUnit = null;
        this.formData.goodsCounts = null;
        this.formData.priceType = null;
      }
    },
  },
  computed: {
    ...mapGetters(["chooseMatchingAgreementObjGetter"]),
    autoNoCompute() {
      return this.isEdit && (this.initPayAmount || this.initPayAmount !== 0) ? true : false;
    },
  },
  mounted() {
    this.getDicDate();
  },
  methods: {
    getDicDate() {
      this.goodsTypeOptions = [];
      this.unitTypeOptions = [];

      $api.other.getGoodsTypeModel
          .GET({
            params: {
              page: 1,
              rows: 100,
            },
          })
          .then((res) => {
            res.data.forEach((item) => {
              var obj = {
                label: item.dictText,
                value: item.dictText,
              };
              this.goodsTypeOptions.push(obj);
            });
          });
      $api.other.getUnitTypeModel
          .GET({
            params: {
              page: 1,
              rows: 100,
            },
          })
          .then((res) => {
            res.data.forEach((item) => {
              var obj = {
                label: item.dictText,
                value: item.dictText,
              };
              this.unitTypeOptions.push(obj);
            });
          });
    },
    computeAmount(val, field) {
      this.clearValidate();

      if (field === "price" || field === "realCount" && (this.formData.price && this.formData.realCount)) {
        // if (this.formData.priceType !== 1) {
        //   return;
        // }
        this.formData.freightAmount = Math.floor(mul(this.formData.price, this.formData.realCount) * 100) / 100;
        this.formData.payAmount = Math.floor(add(this.formData.freightAmount, this.formData.demurrageAmount ? this.formData.demurrageAmount : 0) * 100) / 100;
      }
      if (field === 'freightAmount' || field === 'demurrageAmount') {
        this.formData.payAmount = Math.floor(add(this.formData.freightAmount ? this.formData.freightAmount : 0, this.formData.demurrageAmount ? this.formData.demurrageAmount : 0) * 100) / 100;
      }

    },
    async setParams() {
      const errMap = await this.$refs.xForm.validate().catch((errMap) => errMap);
      if (errMap) {
        this.$emit("setParams", false);
        return;
      } else {
        this.$emit("setParams", this.formData);
      }
    },
    clearValidate() {
      this.$refs.xForm.clearValidate();
    },
  },
};
</script>

<style></style>
